export default {
    setUser(state, { user }) {
      state.token = user.token;
  },logout(state) {
    state.token = null;
    localStorage.removeItem("token");
  }
};